import React from "react";

const WelcomeStatement = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 mt-[100px] lg:py-20">
      <div className="w-full mx-auto text-left md:w-11/12 xl:w-9/12 md:text-center">
        <h1 className="mb-8 text-4xl font-extrabold leading-none tracking-normal text-gray-900 md:text-6xl md:tracking-tight">
          Welcome to Reliable Homecare
        </h1>{" "}
        <p className="px-0 mb-8 text-gray-500 mt-4 text-xl md:text-xl lg:px-24">
          Our values form the heart of our approach. Compassion fuels our every
          action, ensuring that every interaction is infused with empathy and
          understanding. We uphold the highest standards of quality, constantly
          striving for excellence in all our services.Our team of caregivers,
          ensures that every individual receives the highest standard of care.
          From creating personalized care plans to fostering a warm and
          nurturing environment, we go above and beyond to enhance the quality
          of life for our clients.
        </p>
      </div>
      <div className="grid gap-4 row-gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col justify-between p-5 border rounded shadow-sm">
          <div>
            <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-indigo-50">
              <svg
                className="w-12 h-12 text-deep-purple-accent-400"
                stroke="currentColor"
                viewBox="0 0 52 52"
              >
                <polygon
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                  points="29 13 14 29 25 29 23 39 38 23 27 23"
                />
              </svg>
            </div>
            <h6 className="mb-2 font-semibold text-xl text-[#2D24A1] leading-5 ">
              Dedicated to Excellence
            </h6>
            <p className="mb-3 text-medium font-medium text-gray-500 ">
              At Reliable Homecare, we are driven by an unwavering commitment to
              excellence.
            </p>
          </div>
          <a
            href="/aboutPage"
            aria-label=""
            className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800"
          >
            Learn more
          </a>
        </div>
        <div className="flex flex-col justify-between p-5 border rounded shadow-sm">
          <div>
            <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-indigo-50">
              <svg
                className="w-12 h-12 text-deep-purple-accent-400"
                stroke="currentColor"
                viewBox="0 0 52 52"
              >
                <polygon
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                  points="29 13 14 29 25 29 23 39 38 23 27 23"
                />
              </svg>
            </div>
            <h6 className="mb-2 font-semibold text-xl text-[#2D24A1] leading-5">
              Personalized Care
            </h6>
            <p className="mb-3 text-medium font-medium text-gray-500">
              At Reliable Homecare, we tailored support that addresses
              individual needs and preferences
            </p>
          </div>
          <a
            href="/aboutPage"
            aria-label=""
            className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800"
          >
            Learn more
          </a>
        </div>
        <div className="flex flex-col justify-between p-5 border rounded shadow-sm">
          <div>
            <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-indigo-50">
              <svg
                className="w-12 h-12 text-deep-purple-accent-400"
                stroke="currentColor"
                viewBox="0 0 52 52"
              >
                <polygon
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                  points="29 13 14 29 25 29 23 39 38 23 27 23"
                />
              </svg>
            </div>
            <h6 className="mb-2 font-semibold text-xl text-[#2D24A1] leading-5">
              Experienced Caregivers
            </h6>
            <p className="mb-3 text-medium font-medium text-gray-500">
              At Reliable Homecare, our caregivers are skilled professionals who
              provide medical and emotional care.
            </p>
          </div>
          <a
            href="/aboutPage"
            aria-label=""
            className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800"
          >
            Learn more
          </a>
        </div>
        <div className="flex flex-col justify-between p-5 border rounded shadow-sm">
          <div>
            <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-indigo-50">
              <svg
                className="w-12 h-12 text-deep-purple-accent-400"
                stroke="currentColor"
                viewBox="0 0 52 52"
              >
                <polygon
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                  points="29 13 14 29 25 29 23 39 38 23 27 23"
                />
              </svg>
            </div>
            <h6 className="mb-2 font-semibold text-xl text-[#2D24A1] leading-5">
              Quick Response
            </h6>
            <p className="mb-3 text-medium font-medium text-gray-500">
              At Reliable Homecare, we are quick and efficient in support and
              care in unexpected situations.
            </p>
          </div>
          <a
            href="/aboutPage"
            aria-label=""
            className="inline-flex items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800"
          >
            Learn more
          </a>
        </div>
      </div>
    </div>
  );
};
export default WelcomeStatement;
